export const DEFAULT_DESTINATION = "/profile";

export const OAUTH_ERROR_FALLBACK =
	"Gagal masuk dengan Google. Silakan coba lagi.";

const OAUTH_ERROR_MESSAGES: Record<string, string> = {
	account_not_linked:
		"Akun dengan email ini sudah ada tetapi belum terverifikasi, sehingga tidak bisa ditautkan ke Google. Hubungi administrator.",
};

/** Pesan tampilan untuk kode ?error= dari callback OAuth Better Auth; kosong bila tidak ada error. */
export function oauthErrorMessage(code: string | undefined): string {
	if (!code) return "";
	return OAUTH_ERROR_MESSAGES[code] ?? OAUTH_ERROR_FALLBACK;
}

/** Ambil hanya path dari ?redirect= (buang origin/query) supaya tidak jadi open redirect. */
export function safeDestination(
	redirect: string | undefined,
	origin: string,
): string {
	if (!redirect) return DEFAULT_DESTINATION;
	try {
		const { pathname, origin: target } = new URL(redirect, origin);
		return target === origin ? pathname : DEFAULT_DESTINATION;
	} catch {
		return DEFAULT_DESTINATION;
	}
}
